module.exports = __webpack_public_path__ + "Peko faceset.png?304fbf304ff71491e792563cb3a090ed";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Peko faceset.png
// module id = 113
// module chunks = 0